<template>
    <div>
        <div class='list-header-container'>
            <Sort :default_sort='default_sort' @sortListener='sortListener' :mobile_mode='mobile_mode'/>
            <!-- <div class='filter-button-container' v-if='mobile_mode'> -->
            <div class='filter-button-container' v-if='mobile_mode'>
                <Button id='show_list_filters_button' text='Filters' @click='showFilters' />
            </div>
        </div>
<!-- 
        <SidePopOut id='product_filters_popout' :open_watcher='open_filters_watcher' :close_watcher='close_filters_watcher' v-if='mobile_mode'>
            <Filters @updatedFilterListener='updatedFilterListener' :filter_options='filter_options' :filter_data='filter_data' :show_filters_watcher='open_filters_watcher' :filter_checkboxes_disabled='filter_checkboxes_disabled' @closePopOutListener='closePopout' :default_filter_options_watcher='default_filter_options_watcher' :inside_popout='true'/>
        </SidePopOut> -->

    </div>
</template>

<script>
import Sort from '@/ecom/components/products/list/Sort.vue';
import Button from '@/ecom/components/buttons/Button.vue';
import Filters from '@/ecom/components/products/list/Filters.vue';
import SidePopOut from '@/ecom/components/overlays/SidePopOut.vue'
import Separator from '@/ecom/components/separators/Separator.vue';

export default {
    components: {Sort, Button, Filters, SidePopOut, Separator},
    props: ['filter_options', 'filter_data', 'filter_checkboxes_disabled', 'total_product_count', 'title', 'show_recommended_sort', 'default_sort', 'default_filter_options_watcher', 'mobile_mode'],
    emits: ['sortListener', 'updatedFilterListener', 'showMobileFiltersListener'],
    data(){
        return{
            show_filters_watcher: null,
            open_filters_watcher: null,
            close_filters_watcher: null
        }
    },
    methods:{
        sortListener(sort_column, sort_order){
            this.$emit('sortListener', sort_column, sort_order);
        },
        updatedFilterListener(filter_attributes_array){
            this.$emit('updatedFilterListener', filter_attributes_array);
        },
        showFilters(){
            this.$emit('showMobileFiltersListener')
            this.open_filters_watcher = +new Date();
        },
        closePopout(){
            this.close_filters_watcher = +new Date();
        }
    }
    
}
</script>

<style lang="scss" scoped>

.list-header-container{
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 20px;
    //margin-top: 32px;

    @media(max-width: 768px){
        justify-content: space-between;
    }
}

.filter-button-container{
    width: 100px;
}
</style>